import React, { useEffect, useState } from 'react'
import styled from 'styled-components';
import { RowTypeSpaceBetween } from '../../genericComponents/Layouts';
import Text from '../../genericComponents/Text';
import { Select, Spin } from 'antd';
import { THEME } from '../../genericComponents/globalStyles';

import AmplifiersModal from '../components/AmplifiersModal';
import ResultBody from '../components/ResultBody';
import GeneralFilters from '../components/GeneralFilters';
import {useTranslation} from 'react-i18next'; 
import i18next from "i18next";
import axios from 'axios';
import { getQueryVariable } from '../../../helpers/queryhandler';

export default function Home(){
  const langSelected = localStorage.getItem("i18nextLng") || "en";
  const { t } = useTranslation();
  const [dataLoading, setDataLoading] = useState(true);
  const [productsJson, setProductsJson] = useState();
  const [simulationLoading, setSimulationLoading] = useState(false);
  const [simulationData, setSimulationData] = useState();
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [recommendedAmplifier, setRecommendedAmplifier] = useState(null);
  const [width, setWidth] = useState("");
  const [heigth, setHeigth] = useState("");
  const [long, setLong] = useState("");
  const [typePower, setTypePower] = useState("100V");
  const [speaker, setSpeaker] = useState(null);
  const [speakerFilteredList, setSpeakerFilteredList] = useState([]);
  const [availablePower, setAvailablePower] = useState([]);
  const [power, setPower] = useState(null);
  const [simulationType, setSimulationType] = useState(1);
  const [frecuencyRange, setFrecuencyRange] = useState('polars2500Hz');
  const [noiseLevel, setNoiseLevel] = useState("");
  const [earHeight, setEarHeight] = useState("");
  const [manualSelectedAmplifier , setManualSelectedAmplifier ] = useState()
  const [printing, setPrinting] = useState(false);
  const [advancedFilters, setAdvancedFilters] = useState({
    form:"all",
    wooferInch:'all',
    vias:'all',
    enclosure:'all',
    EN54:'all',
    ipRange:'all',
    autoAmplified: 'all'
  });

  useEffect(() => {

    const lang = getQueryVariable('lang');
    if(lang&&(lang==='es'||lang==='en')){
      i18next.changeLanguage(lang)
    }

    if(!productsJson){
      setDataLoading(true)
      axios.get('https://www.eafg.es/eqOne/admin_buildAcSim.php').then(r=>{
        r.data?.amplifiers?.sort((a,b)=>{
          const a1=Number(a.power);
          const b1=Number(b.power);
          const a2=Number(a.multiChannel);
          const b2=Number(b.multiChannel);
          const a3=Number(a.DSP);
          const b3=Number(b.DSP);
          const a4=Number(a.control);
          const b4=Number(b.control);
          const a5=Number(a.talkOver);
          const b5=Number(b.talkOver);
          const a6=Number(a.mixer);
          const b6=Number(b.mixer);
          const a7=Number(a.player);
          const b7=Number(b.player);

          if(a1>b1)return 1;
          if(a1<b1)return -1;
          if(a2>b2)return 1;
          if(a2<b2)return -1;
          if(a3>b3)return 1;
          if(a3<b3)return -1;
          if(a4>b4)return 1;
          if(a4<b4)return -1;
          if(a5>b5)return 1;
          if(a5<b5)return -1;
          if(a6>b6)return 1;
          if(a6<b6)return -1;
          if(a7>b7)return 1;
          if(a7<b7)return -1;
          return 0;
        })
        setProductsJson(r.data);
        console.log(r.data)
        setDataLoading(false);
      }).catch(e=>{
        console.log(e)
        setDataLoading(false)
      });
    }
  }, [])

  useEffect(() => {
    if(dataLoading)return;
    const filteredLoudspeakers = productsJson?.loudspeakers.filter(ls=>{
      if(advancedFilters.form!=="all"&&ls.shape!==advancedFilters.form)return false;
      if(advancedFilters.vias!=="all"&&ls.vias!==advancedFilters.vias)return false;
      if(advancedFilters.EN54!=="all"&&ls.EN54!==advancedFilters.EN54)return false;
      if(advancedFilters.ipRange!=="all"&&ls.IPrange!==advancedFilters.ipRange)return false;
      if(advancedFilters.enclosure!=="all"&&ls.enclosure!==advancedFilters.enclosure)return false;
      if(advancedFilters.wooferInch!=="all"&&ls.inches!==advancedFilters.wooferInch)return false;
      if(advancedFilters.autoAmplified!=="all"&&ls.autoAmplified!==advancedFilters.autoAmplified)return false;
      if(!ls.powers.find(p=>p[typePower]!=="0"))return false;
      return true;
    });
    setSpeakerFilteredList(filteredLoudspeakers);
    setSpeaker(null);
    setPower(null);
  }, [typePower,advancedFilters,dataLoading,productsJson?.loudspeakers]);

  useEffect(() => {
    if(dataLoading)return;
    const powers = productsJson?.loudspeakers.find(ls=>
      ls.idProduct===speaker
    )?.powers?.filter(p=>p[typePower]!=="0");
    setAvailablePower(powers);
    setPower(null);
  }, [speaker,typePower,dataLoading,productsJson?.loudspeakers]);

  if(dataLoading){
    return(
      <CenterLayout>
        <Spin size="large" />
        <Text titleLevel={3} titleSize={1}>{t('time_loading_disclamer')}</Text>
      </CenterLayout>
    )
  }
  return (
    <Container>
      <Contain>
        <RowTypeSpaceBetween style={{alignItems:'center'}}>
          <Text titleSize={4}>{t('acoustic_simulator')}</Text>
          {/* <CustomSelect style={{ width: 120 }} defaultValue={langSelected} onChange={(e)=>i18next.changeLanguage(e)}>
            <Select.Option value="es">{t('spanish')}</Select.Option>
            <Select.Option value="en">{t('english')}</Select.Option>
          </CustomSelect> */}
        </RowTypeSpaceBetween>
        <BodyContainer>
          <GeneralFilters
            setSimulationLoading={setSimulationLoading}
            speakerFilteredList={speakerFilteredList}
            setAdvancedFilters={setAdvancedFilters}
            setSimulationType={setSimulationType}
            setFrecuencyRange={setFrecuencyRange}
            setSimulationData={setSimulationData}
            advancedFilters={advancedFilters}
            simulationType={simulationType}
            availablePower={availablePower}
            frecuencyRange={frecuencyRange}
            setNoiseLevel={setNoiseLevel}
            setEarHeight={setEarHeight}
            setTypePower={setTypePower}
            setSpeaker={setSpeaker}
            noiseLevel={noiseLevel}
            earHeight={earHeight}
            typePower={typePower}
            setHeigth={setHeigth}
            setPower={setPower}
            setWidth={setWidth}
            setLong={setLong}
            speaker={speaker}
            heigth={heigth}
            power={power}
            width={width}
            long={long}
          />
          <ResultBody 
            productsJson={productsJson}
            simulationData={simulationData}
            setIsModalVisible={setIsModalVisible}
            simulationLoading={simulationLoading}
            manualSelectedAmplifier={manualSelectedAmplifier}
            recommendedAmplifier={recommendedAmplifier}
            setRecommendedAmplifier={setRecommendedAmplifier}
            printing={printing}
            setPrinting={setPrinting}
          />
        </BodyContainer>
      </Contain>

      <AmplifiersModal 
        typePower={typePower}
        productsJson={productsJson}
        powerRerquirement={Number(simulationData?.power||0)*Number.parseInt(simulationData?.speakerNumt||0)*1.2}
        isModalVisible={isModalVisible} 
        setSimulationData={setSimulationData}
        setIsModalVisible={setIsModalVisible} 
        setManualSelectedAmplifier={setManualSelectedAmplifier}
        showAmplifier={manualSelectedAmplifier?manualSelectedAmplifier:recommendedAmplifier}
      />
      
    </Container>
  )
}


const Container = styled.div`
  width: 100%;
  padding: 24px 16px;
  display: flex;
  justify-content: center;
`;
const Contain = styled.div`
  width: 100%;
  max-width: 1337px;  
`;
const CustomSelect = styled(Select)`
  width: 100%;
  color:${THEME.colors.darkBlue};
  span{
    color:${THEME.colors.darkBlue};
  }
`;
const CenterLayout = styled.div`
  position: absolute;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 1000px;
  min-width: 820px;
  justify-content: center;
  align-items: center;
  z-index: 0;
`;


const BodyContainer = styled(RowTypeSpaceBetween)`
  @media (max-width: 1337px) {
    flex-direction: column;
    margin:0;
  }
`;